import React from 'react';
import {PieChart} from "react-minimal-pie-chart";

const CoursePieChar = ({myCourse, percentComplete}) => {
    if (!percentComplete) {
        percentComplete = 0;
    }
    return (
        <div className="course-item-left">
            <PieChart
                data={[{value: 1, key: 1, color: '#3c8ee2'}]}
                reveal={percentComplete}
                lineWidth={8}
                background="#bfbfbf"
                lengthAngle={360}
                rounded
                animate
            />
            {myCourse.finalTestQuestionCount !== 0 && myCourse.completionType === 1 && myCourse.finalTestCorrectRate ?
                <div className="percent-course"> {myCourse.finalTestCorrectCount}/{myCourse.finalTestQuestionCount} </div> :
                <div className="percent-course"> {percentComplete}% </div>
            }
        </div>
    )
};

export default CoursePieChar;